var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9817",
    "data-name": "Group 9817",
    transform: "translate(-1107 -574)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9749",
    "data-name": "Group 9749",
    transform: "translate(1107 574)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1722",
    "data-name": "Rectangle 1722",
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21166",
    "data-name": "Path 21166",
    d: "M7.41,18.59,8.83,20,12,16.83,15.17,20l1.41-1.41L12,14ZM16.59,5.41,15.17,4,12,7.17,8.83,4,7.41,5.41,12,10Z",
    transform: "translate(1107 574)",
    fill: "#515151"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRange);
export default __webpack_public_path__ + "static/media/range.840f3de631c09012e99aecc591c1ad7e.svg";
export { ForwardRef as ReactComponent };